import type { ReactNode } from 'react';
import { cn } from './cn';

export interface DetailItem {
  label: string;
  value: ReactNode;
  /** Spans the full width (long text such as notes). */
  wide?: boolean;
}

/** Label/value grid of a card (customer card, project basic information). */
export function DetailGrid({ items }: { items: readonly DetailItem[] }) {
  return (
    <dl className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <div
          key={item.label}
          className={cn('flex flex-col gap-1', item.wide && 'sm:col-span-2 lg:col-span-3')}
        >
          <dt className="text-xs font-medium uppercase tracking-wide text-ink-muted">{item.label}</dt>
          <dd className="text-sm">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
